import { MOCK_CLASS_GROUPS } from 'modules/arena/class-groups/content';
import { StudentSubscription, SubscriptionStatus } from 'modules/arena/subscriptions/types';
import { EnrollmentStatus } from 'modules/arena/class-groups/types';

export const SUBSCRIPTION_STATUS_LABELS: Record<SubscriptionStatus, string> = {
  ativa: 'Ativa',
  pendente_pagamento: 'Pendente de pagamento',
  cancelada: 'Cancelada',
  expirada: 'Expirada',
};

export const SUBSCRIPTION_FILTERS: { value: string; label: string }[] = [
  { value: 'all', label: 'Todas' },
  { value: 'ativa', label: 'Ativas' },
  { value: 'pendente_pagamento', label: 'Pendentes' },
  { value: 'cancelada', label: 'Canceladas' },
];

const ENROLLMENT_TO_SUBSCRIPTION: Record<EnrollmentStatus, SubscriptionStatus> = {
  ativa: 'ativa',
  pendente_renovacao: 'pendente_pagamento',
  cancelada: 'cancelada',
};

const NEXT_BILLING_BY_GROUP: Record<string, string> = {
  'turma-b': '05/10',
  'futevolei-iniciantes': '03/10',
  'pickleball-avancado': '12/10',
  'volei-praia-mista': '08/10',
};

// Cada assinatura vem diretamente do roster das turmas em classGroupsContent, então
// as duas telas nunca ficam dessincronizadas (mesmo aluno, mesma turma, mesmo valor).
export const MOCK_SUBSCRIPTIONS: StudentSubscription[] = MOCK_CLASS_GROUPS.flatMap((group) =>
  group.students.map((student) => {
    const status = ENROLLMENT_TO_SUBSCRIPTION[student.status];
    const lastPaymentStatus = status === 'ativa' ? 'pago' : status === 'pendente_pagamento' ? 'pendente' : 'falhou';

    return {
      id: `sub-${group.id}-${student.id}`,
      studentId: student.id,
      studentName: student.name,
      classGroupName: group.name,
      sport: group.sport,
      monthlyPrice: group.monthlyPrice,
      status,
      renewalMode: group.renewalMode,
      startedAtLabel: student.sinceLabel,
      nextBillingLabel: NEXT_BILLING_BY_GROUP[group.id] ?? '—',
      paymentHistory: [
        { id: `${group.id}-${student.id}-p1`, dateLabel: 'ago/26', amount: group.monthlyPrice, status: 'pago' },
        { id: `${group.id}-${student.id}-p2`, dateLabel: 'set/26', amount: group.monthlyPrice, status: lastPaymentStatus },
      ],
    };
  })
);
